module.exports = __webpack_public_path__ + "static/building2-6b087333db6ec096d1ac524d58ff31cc.svg";